export interface TimezoneOption {
  value: string;
  label: string;
  group: string;
}

export const TIMEZONE_GROUPS = {
  EUROPE: 'Europe',
  AMERICA: 'America',
  ASIA: 'Asia',
  AUSTRALIA: 'Australia',
  AFRICA: 'Africa',
  PACIFIC: 'Pacific',
} as const;

export const TIMEZONES: TimezoneOption[] = [
  // Europe
  {
    value: 'Europe/Amsterdam',
    label: 'Amsterdam (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/London',
    label: 'London (BST/GMT)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/Berlin',
    label: 'Berlin (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/Paris',
    label: 'Paris (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/Rome',
    label: 'Rome (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/Madrid',
    label: 'Madrid (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/Stockholm',
    label: 'Stockholm (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/Zurich',
    label: 'Zurich (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/Vienna',
    label: 'Vienna (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },
  {
    value: 'Europe/Brussels',
    label: 'Brussels (CEST/CET)',
    group: TIMEZONE_GROUPS.EUROPE,
  },

  // America
  {
    value: 'America/New_York',
    label: 'New York (EDT/EST)',
    group: TIMEZONE_GROUPS.AMERICA,
  },
  {
    value: 'America/Chicago',
    label: 'Chicago (CDT/CST)',
    group: TIMEZONE_GROUPS.AMERICA,
  },
  {
    value: 'America/Denver',
    label: 'Denver (MDT/MST)',
    group: TIMEZONE_GROUPS.AMERICA,
  },
  {
    value: 'America/Los_Angeles',
    label: 'Los Angeles (PDT/PST)',
    group: TIMEZONE_GROUPS.AMERICA,
  },
  {
    value: 'America/Toronto',
    label: 'Toronto (EDT/EST)',
    group: TIMEZONE_GROUPS.AMERICA,
  },
  {
    value: 'America/Vancouver',
    label: 'Vancouver (PDT/PST)',
    group: TIMEZONE_GROUPS.AMERICA,
  },
  {
    value: 'America/Sao_Paulo',
    label: 'São Paulo (BRT)',
    group: TIMEZONE_GROUPS.AMERICA,
  },
  {
    value: 'America/Mexico_City',
    label: 'Mexico City (CDT/CST)',
    group: TIMEZONE_GROUPS.AMERICA,
  },

  // Asia
  { value: 'Asia/Tokyo', label: 'Tokyo (JST)', group: TIMEZONE_GROUPS.ASIA },
  {
    value: 'Asia/Shanghai',
    label: 'Shanghai (CST)',
    group: TIMEZONE_GROUPS.ASIA,
  },
  {
    value: 'Asia/Hong_Kong',
    label: 'Hong Kong (HKT)',
    group: TIMEZONE_GROUPS.ASIA,
  },
  {
    value: 'Asia/Singapore',
    label: 'Singapore (SGT)',
    group: TIMEZONE_GROUPS.ASIA,
  },
  { value: 'Asia/Seoul', label: 'Seoul (KST)', group: TIMEZONE_GROUPS.ASIA },
  {
    value: 'Asia/Kolkata',
    label: 'Kolkata (IST)',
    group: TIMEZONE_GROUPS.ASIA,
  },
  { value: 'Asia/Dubai', label: 'Dubai (GST)', group: TIMEZONE_GROUPS.ASIA },
  {
    value: 'Asia/Bangkok',
    label: 'Bangkok (ICT)',
    group: TIMEZONE_GROUPS.ASIA,
  },

  // Australia
  {
    value: 'Australia/Sydney',
    label: 'Sydney (AEST/AEDT)',
    group: TIMEZONE_GROUPS.AUSTRALIA,
  },
  {
    value: 'Australia/Melbourne',
    label: 'Melbourne (AEST/AEDT)',
    group: TIMEZONE_GROUPS.AUSTRALIA,
  },
  {
    value: 'Australia/Perth',
    label: 'Perth (AWST)',
    group: TIMEZONE_GROUPS.AUSTRALIA,
  },
  {
    value: 'Australia/Brisbane',
    label: 'Brisbane (AEST)',
    group: TIMEZONE_GROUPS.AUSTRALIA,
  },
  {
    value: 'Australia/Adelaide',
    label: 'Adelaide (ACST/ACDT)',
    group: TIMEZONE_GROUPS.AUSTRALIA,
  },

  // Africa
  {
    value: 'Africa/Cairo',
    label: 'Cairo (EET)',
    group: TIMEZONE_GROUPS.AFRICA,
  },
  {
    value: 'Africa/Johannesburg',
    label: 'Johannesburg (SAST)',
    group: TIMEZONE_GROUPS.AFRICA,
  },
  {
    value: 'Africa/Lagos',
    label: 'Lagos (WAT)',
    group: TIMEZONE_GROUPS.AFRICA,
  },
  {
    value: 'Africa/Casablanca',
    label: 'Casablanca (WET)',
    group: TIMEZONE_GROUPS.AFRICA,
  },

  // Pacific
  {
    value: 'Pacific/Auckland',
    label: 'Auckland (NZST/NZDT)',
    group: TIMEZONE_GROUPS.PACIFIC,
  },
  {
    value: 'Pacific/Honolulu',
    label: 'Honolulu (HST)',
    group: TIMEZONE_GROUPS.PACIFIC,
  },
  {
    value: 'Pacific/Fiji',
    label: 'Fiji (FJT)',
    group: TIMEZONE_GROUPS.PACIFIC,
  },
];

export const getUserTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const getTimezoneLabel = (timezone: string): string => {
  const found = TIMEZONES.find(tz => tz.value === timezone);
  return found ? found.label : timezone;
};

export const getTimezonesByGroup = (): Record<string, TimezoneOption[]> => {
  return TIMEZONES.reduce(
    (groups, timezone) => {
      if (!groups[timezone.group]) {
        groups[timezone.group] = [];
      }
      groups[timezone.group].push(timezone);
      return groups;
    },
    {} as Record<string, TimezoneOption[]>
  );
};
